import React from 'react';
import { withTranslation } from 'react-i18next';

import { Avatar, Box, Button } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

import OverflowTitle from '../../OverflowTitle';

import { IUserProfilePreviewView } from './interfaces';

import { useStyles } from './styles';

const ParticipantProfilePreviewView = ({
  user,
  fullUserName,
  showFollowMe,
  onFollow,
  t: translate,
}: IUserProfilePreviewView) => {
  const { profileImage, email } = user;
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <Avatar src={profileImage?.url || ''} sx={classes.avatar} />
      <Box sx={classes.userData}>
        <OverflowTitle title={fullUserName} sx={classes.name} />
        <Box sx={classes.emailRow}>
          <MailIcon sx={classes.emailIcon} />
          <OverflowTitle title={email} sx={classes.email} />
        </Box>
        {showFollowMe && (
          <Button sx={classes.followBtn} onClick={onFollow} disableRipple>
            <GroupAddIcon sx={classes.followIcon} />
            {translate('userProfile.findAndFollow')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default withTranslation('common')(ParticipantProfilePreviewView);
